import { iono } from 'global';
import { query, resizeObserver } from '../utils/dom';
import selectors from '../selectors';
import Theme, { buildThemeOptions } from '../utils/theme';
import Tooltips from '../utils/tooltip';

/**
 * Base layout
 */
export default class Layout {
  constructor (player, options) {
    this.options = options;
    this.player = player;
    this.locale = player.locale;

    // this.init(this.options);

    this.onresize = this.onresize.bind(this);
  }

  $ (selector) {
    if (this.$element) {
      return query(selector, this.$element);
    }
  }

  usesTooltips () {
    return true;
  }

  init (options) {
    this.theme = new Theme(buildThemeOptions(options.theme, this));
  }

  getAdContainer () {
    return this.$('.iono-ima-container');
  }

  getAdCustomClickTracker () {
    return this.$('.iono-ima-clicktracker');
  }

  getTheme () {
    return this.theme;
  }

  setTheme (theme) {
    const options = buildThemeOptions(theme, this);
    this.theme.setRounded(options.rounded);
    this.theme.setColors(options.colors);
    return this;
  }

  onstate () {
    if (this.$element) this.$element.setAttribute('data-state', this.player.getState());
  }

  /**
   * Generic handler for duration changes
   *
   * @param {Object} event
   */
  ondurationchange (event) {
    if (!event.defaultPrevented) {
      (this.$(selectors.Duration) || {}).textContent = iono.Player.formatSeconds(event.duration);
    }
  }

  /**
   * Generic handler for position changes
   *
   * @param {Object} event
   */
  ontimeupdate (event) {
    if (!event.defaultPrevented) {
      (this.$(selectors.Position) || {}).textContent = iono.Player.formatSeconds(event.position);
    }
  }

  /**
   * Generic handler for active playlist item changes
   *
   * @param {Object} event
   */
  onplaylistselect (event) {
    if (!event.defaultPrevented) {
      const metadata = this.player.getMetadata();

      (this.$(selectors.MetaTitle) || {}).textContent = metadata.title;
      (this.$(selectors.MetaCreator) || {}).textContent = metadata.creator;
      (this.$(selectors.MetaGrouping) || {}).textContent = metadata.grouping;
    }
  }

  /**
   * Generic handler for error events
   */
  onerror () {
    const error = this.player.getError();
    if (this.$errorMessage) {
      if (error.getLocaleMessage === undefined) {
        this.$errorMessage.textContent = error.message;
      } else {
        this.$errorMessage.textContent = error.getLocaleMessage(this.locale);
      }
    }
    if (this.$errorRetry) {
      if (error.fatal) {
        this.$errorRetry.setAttribute('hidden', true);
      } else {
        this.$errorRetry.removeAttribute('hidden');
      }
    }
  }

  onresize () {}

  /**
   * Generic handler for UI events
   *
   * @param {Object} event
   */
  handleEvent (event) {}

  /**
   * Attach layout to the dom
   *
   * @param {Element} element
   */
  attach (element = this.$element) {
    if (this.$element) this.detach();

    this.$element = element;
    this.$element.classList.add(this.getTheme().className);
    this.$element.setAttribute('data-state', this.player.getState());
    this.getTheme().render();

    document.head.appendChild(this.getTheme().$style);

    // @todo promote tooltips to an effect
    if (this.usesTooltips()) {
      this._deinitTooltips = Tooltips.init({
        container: this.$element
      });
    }

    resizeObserver.observe(this.$element);

    this.$element.addEventListener('click', this);
    this.$element.addEventListener('resize', this.onresize);
  }

  /**
   * Detach layout from the dom
   *
   * @param {Element} element
   */
  detach (element = this.$element) {
    if (this.$element) {
      this.$element.removeEventListener('click', this);
      this.$element.removeEventListener('resize', this.onresize);

      resizeObserver.unobserve(this.$element);
    }

    if (this.usesTooltips() && this._deinitTooltips) {
      this._deinitTooltips();
    }

    this.$element = undefined;
  }

  /**
   * Render layout to the dom
   */
  render () {
    return `<div></div>`;
  }
}
